<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="fw-bold text-primary">
        <i class="fas fa-history ms-2"></i> أرشيف التعليمات المرسلة
      </h4>
      <button @click="refresh" class="btn btn-outline-dark btn-sm">
        <i class="fas fa-sync-alt ms-1"></i> تحديث
      </button>
    </div>

    <!-- جدول التعليمات -->
    <div class="card shadow-sm border-top-primary">
      <div class="table-responsive">
        <table class="table table-hover align-middle text-center mb-0">
          <thead class="table-light">
            <tr>
              <th style="width: 30%;">عنوان التعليمات</th>
              <th>النوع</th>
              <th>المستهدف</th>
              <th>تاريخ الإرسال</th>
              <th>نسبة الاطلاع</th>
              <th>التفاصيل</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in instructions.data" :key="item.id">
              <!-- العنوان -->
              <td class="text-start">
                <div class="fw-bold text-truncate" style="max-width: 300px;">{{ item.title }}</div>
              </td>

              <!-- النوع -->
              <td>
                <span class="badge" :class="item.type === 'urgent' ? 'bg-danger' : 'bg-primary'">
                  {{ item.type === 'urgent' ? 'عاجل' : 'عادي' }}
                </span>
              </td>

              <!-- المستهدف -->
              <td>
                <span v-if="item.target_type === 'all'" class="badge bg-dark">الجميع</span>
                <span v-else class="badge bg-info text-dark">
                  لجنة {{ item.target_committee_id }}
                </span>
              </td>

              <!-- التاريخ -->
              <td class="small text-muted" dir="ltr">
                {{ formatDate(item.created_at) }}
              </td>

              <!-- نسبة القراءة -->
              <td>
                <div class="d-flex align-items-center justify-content-center">
                  <div class="progress flex-grow-1 ms-2" style="height: 10px; max-width: 100px;">
                    <div 
                      class="progress-bar" 
                      :class="getProgressColor(item.readers_count, item.total_target)"
                      role="progressbar" 
                      :style="{ width: calculatePercent(item.readers_count, item.total_target) + '%' }"
                    ></div>
                  </div>
                  <small class="fw-bold">{{ item.readers_count }} / {{ item.total_target }}</small>
                </div>
              </td>

              <!-- زر التفاصيل -->
              <td>
                <button @click="openDetails(item.id)" class="btn btn-sm btn-outline-secondary">
                  <i class="fas fa-eye"></i> متابعة
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- Pagination -->
      <!-- يمكنك إضافة مكون التصفح هنا إذا كنت تستخدم Laravel Pagination -->
    </div>

    <!-- ========================================= -->
    <!-- نافذة التفاصيل (Modal) -->
    <!-- ========================================= -->
    <div v-if="showModal" class="modal-backdrop fade show"></div>
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-light">
            <h5 class="modal-title fw-bold text-primary">
              <i class="fas fa-chart-pie ms-2"></i> تقرير الاطلاع
            </h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          
          <div class="modal-body" v-if="selectedItem">
            
            <div class="alert alert-secondary mb-3">
               <strong>محتوى الرسالة:</strong> {{ selectedItem.instruction.content }}
            </div>

            <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link" 
                  :class="{ active: activeTab === 'read' }" 
                  @click="activeTab = 'read'"
                >
                  <i class="fas fa-check-circle text-success ms-1"></i>
                  تم الاطلاع ({{ selectedItem.readers.length }})
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button 
                  class="nav-link" 
                  :class="{ active: activeTab === 'unread' }" 
                  @click="activeTab = 'unread'"
                >
                  <i class="fas fa-times-circle text-danger ms-1"></i>
                  لم يتم الاطلاع ({{ selectedItem.non_readers.length }})
                </button>
              </li>
            </ul>

            <!-- قائمة من قرأ -->
            <div v-if="activeTab === 'read'">
                <div class="table-responsive">
                    <table class="table table-sm table-striped">
                        <thead><tr><th>اللجنة</th><th>الاسم</th><th>وقت القراءة</th></tr></thead>
                        <tbody>
                            <tr v-for="r in selectedItem.readers" :key="r.id">
                                <td>{{ r.committee_id }}</td>
                                <td>{{ r.name }}</td>
                                <td dir="ltr" class="text-end">{{ formatTime(r.read_at) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- قائمة من لم يقرأ -->
            <div v-if="activeTab === 'unread'">
                 <div class="alert alert-warning small" v-if="selectedItem.non_readers.length > 0">
                    يمكنك التواصل مع هؤلاء الرؤساء لتنبيههم بضرورة فتح النظام.
                 </div>
                 <div class="table-responsive">
                    <table class="table table-sm table-hover">
                        <thead><tr><th>اللجنة</th><th>الاسم</th><th>الحالة</th></tr></thead>
                        <tbody>
                            <tr v-for="u in selectedItem.non_readers" :key="u.id">
                                <td>{{ u.committee_id }}</td>
                                <td>{{ u.name }}</td>
                                <td class="text-danger fw-bold">لم يقرأ</td>
                            </tr>
                             <tr v-if="selectedItem.non_readers.length === 0">
                                <td colspan="3" class="text-center text-success fw-bold py-3">
                                    ممتاز! الجميع قام بالاطلاع.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">إغلاق</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import api from '@/api/axios';

export default {
  name: "AdminSentInstructions",
  data() {
    return {
      instructions: {}, // بيانات الجدول
      showModal: false,
      activeTab: 'read',
      selectedItem: null, // التفاصيل داخل المودال
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      try {
        const res = await api.get('/admin/instructions-history');
        this.instructions = res.data;
      } catch (e) {
        console.error(e);
      }
    },

    async openDetails(id) {
      this.selectedItem = null; // تصفير القديم
      this.showModal = true;
      this.activeTab = 'read';
      
      try {
        const res = await api.get(`/admin/instructions-history/${id}`);
        this.selectedItem = res.data;
      } catch (e) {
        alert("فشل جلب التفاصيل");
        this.showModal = false;
      }
    },

    closeModal() {
      this.showModal = false;
    },

    // دوال مساعدة
    calculatePercent(read, total) {
      if(total === 0) return 0;
      return Math.round((read / total) * 100);
    },
    getProgressColor(read, total) {
      const pct = this.calculatePercent(read, total);
      if(pct === 100) return 'bg-success';
      if(pct > 50) return 'bg-info';
      return 'bg-warning';
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('ar-EG');
    },
    formatTime(date) {
      return new Date(date).toLocaleString('ar-EG');
    }
  }
};
</script>

<style scoped>
.border-top-primary {
    border-top: 4px solid #0d6efd;
}
.modal-backdrop {
    background-color: rgba(0,0,0,0.5);
}
</style>